var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.2 353.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b20000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.5,69.2H14.7c-8.1,0-14.7-6.6-14.7-14.7s6.6-14.7,14.7-14.7h305.7c8.1,0,14.7,6.6,14.7,14.7s-6.6,14.7-14.7,14.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.6,60.5c-3.6-17.9-19.6-31-38-31s-34.4,13-38,31l-28.9-5.8C107.1,23,135.2,0,167.6,0s60.4,23,66.9,54.6l-28.9,5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267,353.2H68.2c-15.4,0-28.3-12.6-29.3-28.6l-15.2-255.4c-.5-8.1,5.7-15.1,13.8-15.6,8.2-.4,15.1,5.7,15.6,13.8l15.2,255.4,198.6.9,15.1-256.2c.5-8.1,7.6-14.2,15.6-13.8,8.1.5,14.3,7.5,13.8,15.6l-15.2,255.4c-1,16.1-13.9,28.6-29.2,28.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.7,299.1c-7.8,0-14.3-6.1-14.7-13.9l-9.8-175.6c-.5-8.1,5.8-15.1,13.9-15.5,7.9-.3,15.1,5.8,15.5,13.9l9.8,175.6c.5,8.1-5.8,15.1-13.9,15.5-.3,0-.6,0-.8,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.5,299.1c-.3,0-.6,0-.8,0-8.1-.5-14.4-7.4-13.9-15.5l9.8-175.6c.4-8.1,7.4-14.3,15.5-13.9,8.1.4,14.4,7.4,13.9,15.5l-9.8,175.6c-.4,7.8-6.9,13.9-14.7,13.9h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.6,299.1c-8.1,0-14.7-6.6-14.7-14.7V108.8c0-8.1,6.6-14.7,14.7-14.7s14.7,6.6,14.7,14.7v175.6c0,8.1-6.6,14.7-14.7,14.7h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/Delete_Red.044502b2ab20a30c61ce979ca38a3b00.svg";
export { ForwardRef as ReactComponent };